"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/es6.object.assign");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const atoms_1 = require("@components/atoms");
const _store_1 = __importDefault(require("@store"));
const _theme_1 = require("@theme");
const _utils_1 = require("@utils"); // Component
var NotificationWidget = function NotificationWidget() {
    var _useGlobal = _store_1.default(function (state) {
        return state.notification;
    }, function (actions) {
        return actions.setNotification;
    }), notification = _useGlobal[0], setNotification = _useGlobal[1];
    var _React$useState = react_1.default.useState(false), visible = _React$useState[0], setVisible = _React$useState[1];
    var _React$useState2 = react_1.default.useState(''), type = _React$useState2[0], setType = _React$useState2[1];
    var _React$useState3 = react_1.default.useState(''), title = _React$useState3[0], setTitle = _React$useState3[1];
    var _React$useState4 = react_1.default.useState(''), message = _React$useState4[0], setMessage = _React$useState4[1];
    var timeoutInstance;
    react_1.default.useEffect(function () {
        if (notification) {
            setType(notification.type);
            setTitle(notification.title);
            setMessage(notification.message);
            setVisible(true);
            if (notification && notification.autoDismiss) {
                timeoutInstance = setTimeout(function () {
                    return setVisible(false);
                }, notification.autoDismiss * 1000);
            }
        }
        else {
            setVisible(false);
        }
    }, [notification]);
    var clearNotification = function clearNotification() {
        clearTimeout(timeoutInstance);
        setVisible(false);
    };
    react_1.default.useEffect(function () {
        return function () {
            clearTimeout(timeoutInstance);
            setNotification(undefined);
        };
    }, []);
    return /*#__PURE__*/ react_1.default.createElement(Wrapper, null, /*#__PURE__*/ react_1.default.createElement(Overflow, null, /*#__PURE__*/ react_1.default.createElement(Content, null, /*#__PURE__*/ react_1.default.createElement(Notification, Object.assign({
        className: (notification === null || notification === void 0 ? void 0 : notification.type) || ''
    }, {
        visible: visible
    }), /*#__PURE__*/ react_1.default.createElement(IconWrapper, null, /*#__PURE__*/ react_1.default.createElement(Icons, null, type === 'confirmation' && /*#__PURE__*/ react_1.default.createElement(Checkmark, null), type === 'warning' && /*#__PURE__*/ react_1.default.createElement(Cross, null))), /*#__PURE__*/ react_1.default.createElement(Copy, null, /*#__PURE__*/ react_1.default.createElement(Title, null, title), /*#__PURE__*/ react_1.default.createElement(Message, null, message)), /*#__PURE__*/ react_1.default.createElement(Actions, null, /*#__PURE__*/ react_1.default.createElement(StyledButton, {
        type: "text",
        onClick: function onClick() {
            return clearNotification();
        }
    }, "Dismiss"))))));
}; // Styling
var Wrapper = styled_components_1.default.div.withConfig({
    displayName: "NotificationWidget__Wrapper",
    componentId: "sc-1f4anw4-0"
})(["z-index:11002;position:fixed;bottom:0;left:0;display:flex;justify-content:center;width:100%;height:auto;max-height:100vh;overflow:auto;pointer-events:none;-webkit-overflow-scrolling:touch;&::-webkit-scrollbar{width:0px;height:0px;}"]);
var Overflow = styled_components_1.default.div.withConfig({
    displayName: "NotificationWidget__Overflow",
    componentId: "sc-1f4anw4-1"
})(["z-index:2;width:100%;height:100%;max-height:100%;pointer-events:none;"]);
var Content = styled_components_1.default.div.withConfig({
    displayName: "NotificationWidget__Content",
    componentId: "sc-1f4anw4-2"
})(["display:flex;flex-direction:column;justify-content:flex-end;align-items:center;width:100%;height:100%;min-height:fit-content;padding:40px 24px;pointer-events:none;", "{padding-top:56px;padding-bottom:56px;}", "{padding-top:64px;padding-bottom:64px;}", "{padding-top:80px;padding-bottom:80px;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop')); // Notification
var Notification = styled_components_1.default.div.withConfig({
    displayName: "NotificationWidget__Notification",
    componentId: "sc-1f4anw4-3"
})(["position:relative;display:flex;flex-wrap:wrap;max-width:760px;background:", ";border:inset 1px solid ", ";box-shadow:0px 16px 24px ", ";margin-bottom:16px;opacity:", ";transform:translate3d(", ") scale3d(", ");transition-delay:0.3s;transition:opacity 0.35s ease-in-out,transform 0.35s ease-in-out;will-change:opacity,transform;pointer-events:", ";&:last-of-type{margin-bottom:0;}&.confirmation{border-left:2px solid ", ";}&.warning{border-left:2px solid ", ";}", "{flex-wrap:nowrap;margin-bottom:24px;}", "{border-left-width:4px !important;}"], _theme_1.palette.snow, _utils_1.rgba(_theme_1.palette.ink, 0.08), _utils_1.rgba(_theme_1.palette.black, 0.12), function (props) {
    return props.visible ? 1 : 0;
}, function (props) {
    return props.visible ? '0, 0, 0' : '0, 5px, 0';
}, function (props) {
    return props.visible ? '1, 1, 1' : '0.98, 0.98, 1';
}, function (props) {
    return props.visible ? 'all' : 'none';
}, _theme_1.palette.green, _theme_1.palette.vermillion, _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'));
var IconWrapper = styled_components_1.default.div.withConfig({
    displayName: "NotificationWidget__IconWrapper",
    componentId: "sc-1f4anw4-4"
})(["display:none;align-self:center;height:100%;padding-left:16px;", "{display:block;padding-left:24px;}"], _utils_1.mediaQuery('tablet'));
var Icons = styled_components_1.default.div.withConfig({
    displayName: "NotificationWidget__Icons",
    componentId: "sc-1f4anw4-5"
})(["position:relative;display:flex;justify-content:center;align-items:center;width:32px;height:32px;border-radius:50%;overflow:hidden;", ".confirmation &{background-color:", ";}", ".warning &{background-color:", ";}", "{width:40px;height:40px;}"], Notification, _theme_1.palette.green, Notification, _theme_1.palette.vermillion, _utils_1.mediaQuery('laptop'));
var Checkmark = styled_components_1.default.span.withConfig({
    displayName: "NotificationWidget__Checkmark",
    componentId: "sc-1f4anw4-6"
})(["position:absolute;left:calc(50% - 2.5px);top:calc(50% - 6.5px);display:block;width:5px;height:10px;border:solid ", ";border-width:0 2px 2px 0;transform:rotate(45deg);", "{left:calc(50% - 3px);top:calc(50% - 7.5px);width:6px;height:12px;border-width:0 2.5px 2.5px 0;}"], _theme_1.palette.white, _utils_1.mediaQuery('laptop'));
var Cross = styled_components_1.default.div.withConfig({
    displayName: "NotificationWidget__Cross",
    componentId: "sc-1f4anw4-7"
})(["position:absolute;display:flex;justify-content:center;align-items:center;width:12px;height:10px;&::before,&::after{position:absolute;background-color:", ";height:2px;width:100%;border-radius:0 1px 1px 0;content:'';}&::before{transform:rotate3d(0,0,1,45deg);}&::after{transform:rotate3d(0,0,1,-45deg);}", "{width:16px;height:14px;}"], _theme_1.palette.white, _utils_1.mediaQuery('laptop'));
var Copy = styled_components_1.default.div.withConfig({
    displayName: "NotificationWidget__Copy",
    componentId: "sc-1f4anw4-8"
})(["display:flex;flex-direction:column;justify-content:center;padding:16px;", "{padding:24px;}"], _utils_1.mediaQuery('tablet'));
var Title = styled_components_1.default.div.withConfig({
    displayName: "NotificationWidget__Title",
    componentId: "sc-1f4anw4-9"
})(["margin-bottom:4px;", " text-indent:0 !important;"], _theme_1.type.labelLarge);
var Message = styled_components_1.default.div.withConfig({
    displayName: "NotificationWidget__Message",
    componentId: "sc-1f4anw4-10"
})(["", ""], _theme_1.type.pLargeSans);
var Actions = styled_components_1.default.div.withConfig({
    displayName: "NotificationWidget__Actions",
    componentId: "sc-1f4anw4-11"
})(["display:flex;flex-direction:column;width:100%;border-top:1px solid ", ";", "{width:auto;border-top:none;border-left:1px solid ", ";}"], _utils_1.rgba(_theme_1.palette.ink, 0.08), _utils_1.mediaQuery('tablet'), _utils_1.rgba(_theme_1.palette.ink, 0.08));
var StyledButton = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(atoms_1.Button, props);
}).withConfig({
    displayName: "NotificationWidget__StyledButton",
    componentId: "sc-1f4anw4-12"
})(["background-color:transparent;width:100%;height:100%;min-height:48px;border-top:1px solid ", ";transform:scale3d(1,1,1) !important;& span{color:", ";}&:first-of-type{border-top:none;}", "{width:auto;}"], _utils_1.rgba(_theme_1.palette.ink, 0.08), _theme_1.palette.ink, _utils_1.mediaQuery('tablet'));
exports.default = NotificationWidget;
